// import React from "react";
// import PageTitle from "./PageTitle";
// import Button from "../Buttons/Button";

// const PageHeader = ({ title, onBack, onSave }) => {
//   return (
//     <div className="flex justify-between items-center mt-3">
//       <PageTitle title={title} icon={"badge"} tag={"h5"} />
//       <div className="flex gap-2">
//         <Button title="Back" size="sm" onClick={onBack} icon="arrow_left_alt" />
//         <Button title="Save" size="sm" onClick={onSave} />
//       </div>
//     </div>
//   );
// };

// export default PageHeader;

// import React from "react";

// const PageHeader = ({ Section, RightSection, className }) => {
//   return (
//     <div
//       className={`flex flex-wrap justify-between items-center gap-x-5 gap-y-2 ${className}`}
//     >
//       <div className="flex-1">
//         <div>{Section}</div>
//       </div>
//       <div>
//         <div className="flex gap-2 items-center">{RightSection}</div>
//       </div>
//     </div>
//   );
// };

// export default PageHeader;

import React from "react";

const PageHeader = ({
  Section,
  RightSection,
  className = "",
  sectionClassName = "",
  rightSectionClassName = "",
}) => {
  return (
    <div
      className={`flex flex-wrap justify-between items-center gap-x-5 gap-y-2 ${className}`}
    >
      {/* Left Section */}
      <div className={`flex-1 ${sectionClassName}`}>{Section}</div>

      {/* Right Section */}
      <div className={`flex gap-2 items-center ${rightSectionClassName}`}>
        {RightSection}
      </div>
    </div>
  );
};

export default PageHeader;
